module.exports = __webpack_public_path__ + "static/media/img_taskforce_optimized.9c41c6c8.jpg";